export { default } from "ember-stereo/-private/utils/stereo-url";
